import http from '../../../../api/http';

// 매칭 업데이트 count 조회
function retrieveMatchingUpdate() {
    return http.get('/mypage/matching/retrieveMatchingUpdate')
}

export default {
    retrieveMatchingUpdate,
};